import { ArrowDown, ArrowUpRight } from "react-bootstrap-icons";

export const Banner = () => (
  <section className="hero page-shell" id="home" aria-labelledby="hero-title">
    <div className="hero-main">
      <p className="eyebrow">
        <span className="status-dot" /> Software engineer & technical leader
      </p>
      <h1 id="hero-title">
        Complex problems.
        <br />
        Thoughtful <em>solutions.</em>
      </h1>
      <p className="hero-intro">
        Hi, I’m Aaron Zhang. I build software that makes complex data useful—and
        help teams do their best work.
      </p>
      <div className="hero-actions">
        <a className="button-dark" href="#experiences">
          Explore my experience <ArrowDown aria-hidden="true" />
        </a>
        <a
          className="text-link"
          href="https://github.com/aaronzz"
          target="_blank"
          rel="noreferrer"
        >
          GitHub <ArrowUpRight aria-hidden="true" />
        </a>
      </div>
    </div>
    <aside className="current-chapter" aria-label="Current chapter">
      <div className="chapter-top">
        <span className="eyebrow">The current chapter</span>
        <span className="chapter-index">04 /</span>
      </div>
      <div className="chapter-body">
        <span className="chapter-kicker">Now at</span>
        <h2>
          Seeq<span>.</span>
        </h2>
        <p className="chapter-role">Staff Software Developer</p>
        <p>February 2026 — Present</p>
      </div>
      <a href="#experiences" className="chapter-bottom">
        <span>
          <span className="status-dot" /> Always building. Always learning.
        </span>
        <ArrowUpRight aria-hidden="true" />
      </a>
    </aside>
    <div className="career-strip">
      <span className="eyebrow">A career in building</span>
      <div className="company-wordmarks">
        <span>IBM</span>
        <span>Qlik</span>
        <span>Mach7</span>
        <span className="current-company">
          Seeq <span className="tiny-label">NOW</span>
        </span>
      </div>
    </div>
  </section>
);
